import axios from 'axios'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../config/api'
import { utcFinalDate, utcIntialDate } from '../../utils/dateHelper'

export const getStockMovements = (
  filters?: Filter[],
  page = 0,
  pageSize = 20,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(`${ApiConfig.StockMovementApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (Array.isArray(element.value)) {
        // Para arrays (como typePositionId, typeMovementId)
        element.value.forEach((val) => {
          url.searchParams.append(element.key, val.toString())
        })
      } else {
        // Mapeo para filtros de rango de fechas de movimiento
        if (element.key === 'initialDateFilter') {
          url.searchParams.append('initialDate', utcIntialDate(element.value))
        } else if (element.key === 'finalDateFilter') {
          url.searchParams.append('finalDate', utcFinalDate(element.value))
        }
        // Mapeo para filtros de rango de fechas de expiración
        else if (element.key === 'initialExpirationDateFilter') {
          url.searchParams.append('initialExpirationDate', utcIntialDate(element.value))
        } else if (element.key === 'finalExpirationDateFilter') {
          url.searchParams.append('finalExpirationDate', utcFinalDate(element.value))
        }
        // Para el resto de filtros
        else {
          url.searchParams.append(element.key, element.value.toString())
        }
      }
    })
  }

  if (orderBy && orderBy.field) {
    url.searchParams.set('sorter', `${orderBy.field},${orderBy.direction}`)
  }

  return axios.get(url.toString())
}

export const exportStockMovementsToExcel = (filters?: Filter[]) => {
  const date = new Date()
  const offset = date.getTimezoneOffset()

  const url = new URL(`${ApiConfig.StockMovementApi}/StockMovementExcel`)
  url.searchParams.set('offset', offset.toString())

  if (filters) {
    filters.forEach((element) => {
      if (Array.isArray(element.value)) {
        element.value.forEach((val) => {
          url.searchParams.append(element.key, val.toString())
        })
      } else {
        // Mapeo para filtros de rango de fechas de movimiento
        if (element.key === 'initialDateFilter') {
          url.searchParams.append('initialDate', utcIntialDate(element.value))
        } else if (element.key === 'finalDateFilter') {
          url.searchParams.append('finalDate', utcFinalDate(element.value))
        }
        // Mapeo para filtros de rango de fechas de expiración
        else if (element.key === 'initialExpirationDateFilter') {
          url.searchParams.append('initialExpirationDate', utcIntialDate(element.value))
        } else if (element.key === 'finalExpirationDateFilter') {
          url.searchParams.append('finalExpirationDate', utcFinalDate(element.value))
        }
        // Para el resto de filtros
        else {
          url.searchParams.append(element.key, element.value.toString())
        }
      }
    })
  }

  return axios.get(url.toString())
}
